import React from 'react'
import { useForm } from './consumers'
import { useSteps } from './consumers'

const Navigation = () => {
    const { stepIndex, steps, stepNext, stepPrev, step, setStepSubmitted, setStepIndex } = useSteps()

    const Form = useForm()

    const { isError, errors } = Form

    const withNextButton = stepIndex < steps.length - 1 && step.submit === false

    const withPrevButton = stepIndex > 0

    return (
        step.navigation && (
            <div className="fixed border border-[#ECECEC] bg-white bottom-0 left-0 right-0 flex justify-center overflow-hidden py-[14px] px-[36px] mx-auto w-full shadow-orderwizard-nav z-30">
                <div className='max-w-[1280px] w-full flex flex-wrap justify-between gap-2'>
                    {withPrevButton && (
                        <button type='button' onClick={stepPrev} className='flex hover:bg-transparent items-center leading-none justify-center rounded-[12px] py-4 px-9 font-[400] text-[17px] bg-transparent text-white w-full max-w-[100px] md:max-w-[232px] hover:text-[#B71922] select-none hover:underline'>
                            <span className='block lg:w-[160px] text-[#B71922]'>Vorige</span>
                        </button>
                    )}

                    {withNextButton && (
                        <button onClick={stepNext} type="button"
                            className={`flex items-center leading-none hover:underline ${isError ? 'bg-red-500' : 'bg-[#B71922]'} justify-center text-white border border-[#B71922] rounded-[12px] py-4 px-9 font-[400] text-[17px] w-full max-w-[100px] md:max-w-[232px] select-none ml-auto`}>
                            <span className='block lg:w-[160px]'>Volgende</span>
                        </button>
                    )}

                    {step.finish && (
                        // <div className='ml-auto inline-flex items-center'>
                        <button onClick={() => {
                            setStepSubmitted(true)

                            if (Object.keys(errors).length === 0) {
                                setStepIndex(steps.length - 1)
                            }
                        }} className={`flex items-center leading-none hover:underline ${isError ? 'bg-red-500' : 'bg-[#B71922]'} shrink-0 py-4 px-9 rounded-[10px] font-semibold text-white ml-auto gap-2 select-none`} type={step.submit ? 'submit' : 'button'}>
                            <span className='block lg:w-[160px] text-white'>Volgende</span>
                            <svg width="14" height="10" className='rotate-[180deg]' viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.10571 0.237981C5.47143 -0.0791647 6.06 -0.0791648 6.42571 0.237981C6.60857 0.396554 6.7 0.602203 6.7 0.810329C6.7 1.01846 6.60857 1.22411 6.42571 1.38268L3.18571 4.18991L13.0657 4.18991C13.58 4.18991 14 4.55166 14 5.00012C14 5.44858 13.5829 5.81033 13.0657 5.81033L3.18571 5.81033L6.42571 8.61756C6.79143 8.93471 6.79143 9.44512 6.42571 9.76226C6.06 10.0794 5.47143 10.0794 5.10571 9.76226L0.274286 5.57247C0.0971427 5.42133 -2.09135e-07 5.21568 -2.18557e-07 5.00012C-2.27979e-07 4.78456 0.0971426 4.57891 0.274285 4.42777L5.10571 0.237981Z" fill="currentColor" />
                            </svg>
                        </button>
                        // </div>
                    )}

                    {step.submit && (
                        <button className={`flex items-center leading-none hover:underline ${isError ? 'bg-red-500' : 'bg-[#B71922]'} shrink-0 py-4 px-9 rounded-[10px] font-semibold text-white ml-auto gap-2 select-none`} type="submit">
                            <span className='block lg:w-[160px]'>Volgende</span>
                        </button>
                    )}
                </div>
            </div>
        )
    )
}

export default Navigation